const faqData = [
  {
    id: '1',
    title: 'Invite partners — earn Cash, Tgem, and TON!',
    description: [
      'When a friend joins the game using your referral link, you start receiving rewards based on their progress',
      'Each time your partner reaches a new account level, you get bonuses in Tgem and Cash',
      'If you have VIP status, your Tgem and Cash rewards are doubled!',
      'Best part — you earn up to 10% from all purchases made by your partners. The more they spend, the more you earn!',
    ],
  },
  {
    id: '2',
    title: 'What’s the Stars exchange rate for payouts?',
    description: [
      'All rewards from friends’ purchases in Stars are calculated at a fixed rate: 1 Star = $0.015',
      'Example: your partner spends 100 Stars, and your revenue share is 10%: 100 × 0.015 × 10% = $0.15 (paid in TON at the current rate) to your balance.',
    ],
  },
  {
    id: '3',
    title: 'Withdrawal details',
    description: [
      'You can only withdraw the full balance',
      'Minimum withdrawal amount is {{amount}} USD',
      'The withdrawal fee is deducted from the amount and depends on the current load on the TON blockchain',
    ],
  },
];

export { faqData };
